module.exports = __webpack_public_path__ + "media/images/front/review_star_01-e31e1b27c3a157891a30c04670eef71e.png";